'use client'
import PrimaryButton from '@/components/ui/buttons/PrimaryButton';
import { getActiveLocale } from '@/utils/active-locale';
import { useRouter } from 'next/navigation';
import React from 'react';

interface ButtonsProps {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  dictionary: any;
}

export const Buttons: React.FC<ButtonsProps> = ({ dictionary }) => {
  const navigate = useRouter(); 
  const activeLocale = getActiveLocale();

  const handleVacancies = () => {

    navigate.push('/' + activeLocale + '/voor-talenten/vacatures');
  };

  const handleOurApproach = () => {
    navigate.push('/' + activeLocale + '/voor-talenten/onze-aanpak');
  };

  return (
    <div className='flex gap-2 items-start max-sm:flex-col max-sm:w-full'>
      <PrimaryButton onClick={handleVacancies} label={dictionary.home.find} bgColor='bg-brand-600' hoverBgColor='hover:bg-brand-700' textColor='text-white' />
      <PrimaryButton onClick={handleOurApproach} label={dictionary.home.our_approach} bgColor='bg-dark-900' hoverBgColor='hover:bg-dark-800' textColor='text-white' />
    </div>
  );
};
